import Service from "../../AuthService";

const ExampleProduct = {
    getExampleProduct(data) {
        return Service.get(`/example_product?start_date=${data.start_date}&end_date=${data.end_date}&customer_id=${data.customer_id}&seller_id=${data.seller_id}`);
    },
};

export default ExampleProduct;
